import React from 'react'
import BaseComponent from "../../pages/base/BaseComponent";
import {Button, Card, Image, Table} from "@themesberg/react-bootstrap";
import label from "enqc-utilities/src/label/Label"
import {Link} from "react-router-dom";
import {Routes} from "../../routes";
import Endpoint from "enqc-utilities/src/api/Endpoint";
import {getUser} from "../../utils/StorageUtil";
import PropTypes from 'prop-types';
import {DD_MM_YYYY_HH_MM_SS, DD_MMMM_YYYY_HH_MM_SS, PARAM_DATE_FORMAT} from "../../utils/Global";
import PaginationTable from "../../components/PaginationTable";
// import AssemblyDetailPage from "./AssemblyDetailPage";
import {isEmpty, navigate, parseDate} from "enqc-utilities/src/utils/Utilities";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faHistory, faUser} from "@fortawesome/free-solid-svg-icons";
import AssemblyHistoryModal from "../../components/AssemblyHistoryModal";
import AssemblyDetailPage from "./AssemblyDetailPage";
import {ASSEMBLY_STATUS_COLOR} from "enqc-utilities/src/utils/Global";
import ModelDetailInformationModal from "../../components/ModelDetailInformationModal";
import AssemblyHistoryDetailModal from "../../components/AssemblyHistoryDetailModal";
import UserDetailInformationModal from "../../components/UserDetailInformationModal";
import ApplicationIcons from "enqc-utilities/src/misc/ApplicationIcons";


class AssemblyTable extends BaseComponent{

    constructor(props) {
        super(props);
        this.state = {
            show:false,
            search: "",
            user : getUser(),
            assemblyStatus:props.assemblyStatus?props.assemblyStatus:{},
            tabDataCallback:props.tabDataCallback?props.tabDataCallback:{},
            filteredUsers:props.filteredUsers?props.filteredUsers:new Set([]),
            filteredModelCategories:props.filteredModelCategories?props.filteredModelCategories:new Set([]),
            filteredModels:props.filteredModels?props.filteredModels:new Set([]),
            startCreatedAt:props.startCreatedAt?props.startCreatedAt:undefined,
            endCreatedAt:props.endCreatedAt?props.endCreatedAt:undefined,
            startUpdatedAt:props.startUpdatedAt?props.startUpdatedAt:undefined,
            endUpdatedAt:props.endUpdatedAt?props.endUpdatedAt:undefined,
            page: 1,
            assemblies:[],
            totalPage: 0,
            totalElement: 0,
            pageElement: 0,
            assemblyHistoryModal : false,
            assemblyHistoryDetailModal : false,
            modelDetailInformationModal:false,
            selectedAssembly : {},
            selectedAssemblyHistory: {},
            selectedUser:{},
            userInformationModal:false,
        }
    }
    componentDidMount() {
        super.componentDidMount();
        let assemblyStatus = this.state.assemblyStatus??{}
        this.refresh()
        // this.fetchAssemblies(undefined, undefined, undefined)
    }

    componentWillReceiveProps(props, nextContext) {
        if(this.props!=props) {
            let show = props.show ? props.show : false
            let assemblyStatus = props.assemblyStatus ? props.assemblyStatus : {}
            let tabDataCallback = props.tabDataCallback ? props.tabDataCallback : {}
            let search = props.search?props.search:''
            let sortOption = props.sortOption?props.sortOption:{}
            let filteredUsers = props.filteredUsers?props.filteredUsers:new Set([])
            let filteredModelCategories = props.filteredModelCategories?props.filteredModelCategories:new Set([])
            let filteredModels = props.filteredModels?props.filteredModels:new Set([])
            let startCreatedAt = props.startCreatedAt?props.startCreatedAt:undefined
            let endCreatedAt = props.endCreatedAt?props.endCreatedAt:undefined
            let startUpdatedAt = props.startUpdatedAt?props.startUpdatedAt:undefined
            let endUpdatedAt = props.endUpdatedAt?props.endUpdatedAt:undefined
            this.setState({show, assemblyStatus, tabDataCallback, filteredUsers, filteredModelCategories, filteredModels, startCreatedAt, endCreatedAt, startUpdatedAt, endUpdatedAt}, () => {
                if (show && !this.props.show) {
                    this.fetchAssemblies(search, sortOption, filteredUsers, filteredModelCategories, filteredModels, startCreatedAt, endCreatedAt, startUpdatedAt, endUpdatedAt)
                }
            })
        }
    }

    goToPage(page){
        this.setState({page}, () => {
            this.refresh()
        })
    }

    refresh(){
        let {search, sortOption, filteredUsers, filteredModelCategories, filteredModels, startCreatedAt, endCreatedAt, startUpdatedAt, endUpdatedAt} = this.state
        this.fetchAssemblies(search, sortOption, filteredUsers, filteredModelCategories, filteredModels, startCreatedAt, endCreatedAt, startUpdatedAt, endUpdatedAt)
    }


    fetchAssemblies = (search, sortOption, filteredUsers, filteredModelCategories, filteredModels, startCreatedAt, endCreatedAt, startUpdatedAt, endUpdatedAt, downloadExcel) => {
        let {user, assemblyStatus, assemblies, tabDataCallback} = this.state
        let filterSmartDeviceIds = []
        let filterUserIds = []
        if(filteredUsers){
            filterUserIds = new Array()
            filteredUsers.forEach((item)=>{
                filterUserIds.push(item.id)
            })
        }
        let filterModelCategoryIds = []
        if(filteredModelCategories){
            filterModelCategoryIds = new Array()
            filteredModelCategories.forEach((item)=>{
                filterModelCategoryIds.push(item.id)
            })
        }
        let filterModelIds = []
        if(filteredModels){
            filterModelIds = new Array()
            filteredModels.forEach((item)=>{
                filterModelIds.push(item.id)
            })
        }
        if(!sortOption){
            sortOption = {}
        }
        if(startCreatedAt){
            startCreatedAt = parseDate(startCreatedAt, PARAM_DATE_FORMAT)
        }
        if(endCreatedAt){
            endCreatedAt = parseDate(endCreatedAt, PARAM_DATE_FORMAT)
        }
        if(startUpdatedAt){
            startUpdatedAt = parseDate(startUpdatedAt, PARAM_DATE_FORMAT)
        }
        if(endUpdatedAt){
            endUpdatedAt = parseDate(endUpdatedAt, PARAM_DATE_FORMAT)
        }
        this.setState({
            search, sortOption, filteredUsers, filteredModelCategories, filteredModels, startCreatedAt, endCreatedAt, startUpdatedAt, endUpdatedAt
        }, async () => {
            let params = {
                params :{
                    assemblyStatusId : assemblyStatus.id==0?undefined:assemblyStatus.id,
                    ascending: sortOption.ascending,
                    sortir: sortOption.sortir,
                    search: search,
                    userIds:filterUserIds.join(','),
                    modelCategoryIds:filterModelCategoryIds.join(","),
                    modelIds:filterModelIds.join(","),
                    page: this.state.page - 1,
                    startCreatedAt, endCreatedAt, startUpdatedAt, endUpdatedAt
                }
            }
            if(downloadExcel){
                await this.asyncDownloadGet(Endpoint.API.ASSEMBLIES_DOWNLOAD_EXCEL, params, null, false, false)
            }else{
                this.get(Endpoint.API.NATIVE_ASSEMBLIES, params, null, response=>{
                    if(response.code===200){
                        let assemblies = response.data
                        let totalPage = response.totalPage
                        let totalElement = response.totalElement
                        let pageElement = response.pageElement
                        this.setState({assemblies:assemblies, totalPage, totalElement, pageElement}, () => {
                            if(tabDataCallback){
                                tabDataCallback(assemblyStatus.id, totalElement)
                            }
                        })
                    } else{
                        // this.props.history.goBack();
                    }
                }, true, true)
            }
        })
    }


    render() {
        let {user, assemblies, assemblyHistoryModal, assemblyHistoryDetailModal, modelDetailInformationModal, selectedAssembly, selectedAssemblyHistory,
            selectedUser, userInformationModal,
            page, pageElement, totalPage, totalElement} = this.state
        let {model} = selectedAssembly
        if(!model){
            model = {}
        }
        return (
            <React.Fragment>
                <AssemblyHistoryModal
                    show={assemblyHistoryModal}
                    assembly={selectedAssembly}
                    onSelect={(selectedAssemblyHistory) => {
                        this.setState({selectedAssemblyHistory, assemblyHistoryDetailModal:true})
                    }}
                    onClose={()=>{
                        this.setState({assemblyHistoryModal:false, selectedAssembly:{}})
                    }}/>
                <AssemblyHistoryDetailModal
                    assemblyHistory={selectedAssemblyHistory}
                    show={assemblyHistoryDetailModal}
                    onClose={() => {
                        this.setState({assemblyHistoryDetailModal:false})
                    }}
                />
                <ModelDetailInformationModal
                    model={model}
                    show={modelDetailInformationModal}
                    onClose={() => {
                        this.setState({modelDetailInformationModal:false, selectedAssembly:{}})
                    }}/>
                <UserDetailInformationModal
                    {...this.props}
                    user={selectedUser}
                    show={userInformationModal}
                    onClose={() => {
                        this.setState({userInformationModal:false, selectedUser:{}})
                    }}/>
                {this.renderMobileList()}
                {this.renderDesktopTable()}
                {this.renderEmpty()}
                <PaginationTable
                    onSelect={(page) => {
                        this.goToPage(page)
                    }}
                    showingRow={assemblies.length}
                    currentPage={page}
                    pageCount={totalPage}
                    totalElement={totalElement}/>
            </React.Fragment>
        );
    }

    renderDesktopTable(){
        let {assemblies,  selectedAssembly,
            page, pageElement} = this.state
        let {model} = selectedAssembly
        if(!model){
            model = {}
        }

        return(
            <Card.Body className="p-0 d-none d-sm-block">
                <Table size="sm" hover className="table-sm align-items-center p-0">
                    <thead>
                    <tr className={"bg-light"}>
                        <th className="border-bottom pl-3 pr-3" style={{maxWidth:'30px'}}>#</th>
                        <th className="border-bottom pl-3 pr-3 border-end" style={{maxWidth:'190px'}}>{label.Reference}</th>
                        <th className="border-bottom pl-3 pr-3 border-end" style={{maxWidth:'150px'}}>{label.FWVersion}/{label.Controller}</th>
                        <th className="border-bottom pl-3 pr-3 border-end" style={{maxWidth:'160px'}}>{label.ModelCategory}/{label.Model}</th>
                        <th className="border-bottom pl-3 pr-3 border-end text-center" style={{maxWidth:'150px'}}>{label.User}</th>
                        <th className="border-bottom pl-3 pr-3 border-end text-center" style={{maxWidth:'150px'}}>{label.Status}</th>
                        <th className="border-bottom pl-3 pr-3 border-end text-center" style={{maxWidth:'150px'}}>{label.History}</th>
                        <th className="border-bottom pl-3 pr-3 border-end text-center" style={{maxWidth:'180px'}}>{label.Created}</th>
                        <th className="border-bottom pl-3 pr-3 text-center" style={{maxWidth:'190px'}}>{label.Updated}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {assemblies.map((assembly, index) => (
                        <tr key={index}>
                            <td style={{maxWidth:'30px'}} className='pl-3 pr-3'>
                                <Card.Link as={Link} to={Routes.Invoice.path} className="fw-normal">
                                    {((page - 1) * pageElement) + (index+1)}
                                </Card.Link>
                            </td>
                            <td style={{maxWidth:'190px'}} className='text-wrap pl-3 pr-3 border-end'>
                                <span className="fw-normal fw-bolder">
                                    <Link
                                        style={{textDecoration:'underline'}}
                                        to={"#"}
                                        onClick={(event) => {
                                            event.preventDefault()
                                            navigate(this.props, AssemblyDetailPage.ENDPOINT+"?reference="+assembly.reference)
                                        }}>
                                        {assembly.reference}
                                    </Link>
                                </span>
                            </td>
                            <td style={{maxWidth:'150px'}} className='text-wrap pl-3 pr-3 border-end'>
                                    <span className="text-blue fw-400 text-italic">
                                        {isEmpty(assembly.fwVersion)?"-":assembly.fwVersion}
                                    </span>
                                <br/>
                                <span className="fw-normal fw-bolder">
                                    {isEmpty(assembly.controller)?"-":assembly.controller}
                                </span>
                            </td>
                            <td style={{maxWidth:'160px'}} className='text-wrap pl-3 pr-3  border-end text-left'>
                                <span className="text-blue fw-400 text-italic">
                                        {assembly.model.modelCategory.name}
                                </span>
                                <br/>
                                <span className="fw-normal fw-bolder">
                                    <Link
                                        className="bg-transparent text-black p-0 fw-bolder text-underline rounded-0 border-0"
                                        onClick={event => {
                                            event.preventDefault()
                                            this.setState({modelDetailInformationModal:true, selectedAssembly:assembly})
                                        }}>
                                        {assembly.model.systemType}
                                    </Link>
                                </span>
                            </td>
                            <td style={{maxWidth:'180px'}} className='pl-3 pr-3 border-end text-center'>
                                <Button
                                    className="btn-outline-info"
                                    variant="outline-info"
                                    size="sm"
                                    onClick={e => {
                                        e.preventDefault()
                                        this.showPostProgress()
                                        this.fetchUserInformation(assembly.user.id, (user)=>{
                                            this.closePostProgress()
                                            this.setState({userInformationModal:true, selectedUser:user})
                                        })
                                    }}>
                                    <FontAwesomeIcon size="sm" icon={faUser}/>
                                    &nbsp;
                                    {assembly.user?assembly.user.firstname+" / "+assembly.user.manufacturingSite.name:""}
                                </Button>
                            </td>
                            <td style={{maxWidth:'180px'}} className='pl-3 pr-3 border-end text-center'>
                                <Button
                                    size="sm"
                                    className="fw-normal font-small"
                                    disabled={true}
                                    style={{backgroundColor:(assembly.assemblyStatus?ASSEMBLY_STATUS_COLOR[assembly.assemblyStatus.name]:undefined)}}>
                                    {assembly.assemblyStatus?label(assembly.assemblyStatus.label):"-"}
                                </Button>
                            </td>
                            <td style={{maxWidth:'180px'}} className='pl-3 pr-3 border-end text-center'>
                                <Button
                                    size="sm"
                                    className="fw-normal font-small"
                                    onClick={event => {
                                        this.setState({assemblyHistoryModal:true, selectedAssembly:assembly})
                                    }}>
                                    <FontAwesomeIcon icon={faHistory} />
                                </Button>
                            </td>
                            <td style={{maxWidth:'150px'}} className='text-wrap pl-3 pr-3 border-end text-center'>
                                <span className="fw-normal">
                                    {parseDate(assembly.created, DD_MM_YYYY_HH_MM_SS)}
                                </span>
                            </td>
                            <td style={{maxWidth:'180px'}} className='text-wrap pl-3 pr-3 border-end text-center'>
                                <span className="fw-normal">
                                    {parseDate(assembly.updated, DD_MM_YYYY_HH_MM_SS)}
                                </span>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </Table>
            </Card.Body>

        )
    }

    renderMobileList(){
        let {assemblies,  selectedAssembly,
            page, pageElement} = this.state
        let {model} = selectedAssembly
        if(!model){
            model = {}
        }
        return(
            <Card className="table-wrapper table-responsive d-block d-md-none bg-transparent border-0">
                {assemblies.map((assembly, index)=>{
                    return(
                        <Card.Body
                            style={{backgroundColor:(index+1)%2>0?"#f5f1ea":"#00000000", cursor:'pointer', border: '1px solid #dee2e6', borderRadius: '0.25rem' }}
                            className="p-0 mb-2"
                            onClick={event => {
                                event.preventDefault()
                                navigate(this.props, AssemblyDetailPage.ENDPOINT+"?reference="+assembly.reference)
                            }}>
                            <tr>
                                <td style={{whiteSpace:'nowrap', width:'9%'}} rowSpan="3" className="text-center align-items-center align-content-center fs-8 fw-bold text-white ps-2 pe-2 rounded-start bg-primary">
                                    #{((page - 1) * pageElement) + (index+1)}
                                </td>
                                <td className="text-left text-wrap p-1">
                                    <span className="text-info fw-bolder fs-6">{assembly.reference}</span>
                                </td>
                                <td style={{borderBottom:'none'}} className="text-right font-italic text-green fs-9 p-1" colSpan="2">{parseDate(assembly.updated, DD_MMMM_YYYY_HH_MM_SS)}</td>
                            </tr>
                            <tr>
                                <td colSpan="2" className="p-1">
                                    <span
                                        className="fw-bolder font-small fs-6"
                                        style={{color:(assembly.assemblyStatus?ASSEMBLY_STATUS_COLOR[assembly.assemblyStatus.name]:undefined)}}>
                                                ({assembly.assemblyStatus?label(assembly.assemblyStatus.label):"-"})
                                        </span>
                                    <br/>
                                    <span className="text-dark fs-8">{assembly.model?assembly.model.systemType:""}</span>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-1">
                                    <span className="fs-8">{label.PN}:</span><span className="text-italic fs-7 text-info">{assembly.model?assembly.model.partNumber:""}</span>
                                </td>
                                <td className="text-right p-1" style={{whiteSpace:'nowrap'}}>
                                    <Button
                                        className="btn-outline-info"
                                        variant="outline-info" size="sm"
                                        onClick={e => {
                                            e.preventDefault()
                                            e.stopPropagation()
                                            this.showPostProgress()
                                            this.fetchUserInformation(assembly.user.id, (user)=>{
                                                this.closePostProgress()
                                                this.setState({userInformationModal:true, selectedUser:user})
                                            })
                                        }}>
                                        <FontAwesomeIcon size="sm" icon={faUser}/>
                                        &nbsp;
                                        {assembly.user?assembly.user.firstname+" / "+assembly.user.manufacturingSite.name:""}
                                    </Button>
                                </td>
                            </tr>
                        </Card.Body>
                    )
                })}
            </Card>
        )
    }

    renderEmpty(){
        let {assemblies}= this.state
        if(!assemblies){
            assemblies = []
        }

        if(assemblies.length<=0){
            return (
                <Card className="mb-3">
                    <Card.Body>
                        <div className="w-100 h-100 text-center align-content-center justify-content-center align-items-center" style={{minHeight:'200px'}}>
                            <Image
                                className="p-1"
                                style={{
                                    width: '150px',
                                    height: '150px',
                                    objectFit: 'cover',
                                    opacity: 0.2,
                                    filter : 'blur(1px)'
                                }}
                                src={ApplicationIcons.Icons.emptyBox}/>
                            <br/>
                            <span>Empty data..</span>
                        </div>
                    </Card.Body>
                </Card>
            )
        }
        return(null)
    }



}
AssemblyTable.propTypes = {
    show:PropTypes.bool.isRequired,
    assemblyStatus:PropTypes.any.isRequired,
    onSelect:PropTypes.func.isRequired,
    tabDataCallback:PropTypes.func,
}


export default AssemblyTable